import React, { useEffect } from 'react';
import MuiAlert from '@material-ui/lab/Alert';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import {
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grow,
  Snackbar,
  Table,
  TableBody,
  TableHead,
  TableRow,
} from '@material-ui/core';
import 'date-fns';
import ClearIcon from '@material-ui/icons/Clear';
import { storeContext } from '../provider/Provider';
import {
  StyledContentTableCell,
  StyledContentTableHeadCell,
  StyledContentTableHeadCell1,
  StyledContentTableHeadCell2,
} from '../../customUI/table/TableStyles';
import { contentActions } from '../../store/content-reducer';
import useStyles from '../leads/LeadsFullView.style';
import GreenButton from '../../customUI/GreenButton';
import RedButton from '../../customUI/RedButton';
import DefaultInput from '../../customUI/DefaultInput';

function Alert(props) {
  // eslint-disable-next-line
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const { REACT_APP_FLASK_API_URL } = process.env;

const AssignedPages = () => {
  const classes = useStyles();
  const history = useHistory();
  const { state, dispatch } = React.useContext(storeContext);
  const [openDialog, setOpenDialog] = React.useState(false);
  const [openNotification, setOpenNotification] = React.useState(false);
  const [notificationAction, setNotificationAction] = React.useState(false);
  const [isInternalFetching, setIsInternalFetching] = React.useState(false);
  const [tableBodyHeight, setTableBodyHeight] = React.useState(0);
  const [rejectComment, ChangeRejectComment] = React.useState('');
  const handleNotificationClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenNotification(false);
  };

  const updateRows = () => {
    if (document.getElementById('tableBody')) {
      setTableBodyHeight(
        document.getElementById('tableBody').clientHeight > 300
          ? document.getElementById('tableBody').clientHeight
          : 300
      );
    }
    setIsInternalFetching(true);
    axios
      .get(`${REACT_APP_FLASK_API_URL}/v1/assigned-pages/${state.websiteSwitch.currentWebsite}`)
      .then((resAssignedPages) => {
        if (!resAssignedPages.data.error) {
          setIsInternalFetching(false);
          dispatch({
            type: contentActions.CONTENT_SET_ALL,
            payload: {
              assignPageFeature: {
                total: resAssignedPages.data.data.total,
                rows: resAssignedPages.data.data.values,
              },
            },
          });
        }
      });
  };

  useEffect(() => {
    if (!state.websiteSwitch.currentWebsiteSettings.assignPageFeature) {
      history.push('/');
    }
    updateRows();
  }, []);

  const handleCheckBox = (event) => {
    dispatch({
      type: contentActions.CONTENT_CHECK_BY_ID_ASSIGNED_PAGES,
      payload: {
        id: event.target.name,
        checked: event.target.checked,
      },
    });
  };

  const handleCheckAll = (event) => {
    dispatch({
      type: contentActions.CONTENT_CHECK_ALL_ASSIGNED_PAGES,
      payload: {
        checked: event.target.checked,
      },
    });
  };
  const approve = (data) => {
    const approveStatement = 'approve';
    axios
      .post(
        `${REACT_APP_FLASK_API_URL}/v1/client-content/${approveStatement}/${state.websiteSwitch.currentWebsite}`,
        data
      )
      .then(() => {
        updateRows();
        axios
          .get(
            `${REACT_APP_FLASK_API_URL}/dash2-proxy/client-content/websites/${state.websiteSwitch.currentWebsite}/analytics/totals/`
          )
          .then((res) => {
            if (res.status === 200) {
              dispatch({
                type: contentActions.CONTENT_SET_ALL,
                payload: {
                  contentPipeline: res.data['by-status'],
                },
              });
            }
          });
      });
  };

  const handleApproveSelected = (approved) => {
    const data = { pages: {} };
    Object.keys(state.content.assignPageFeature.checked).forEach((key) => {
      if (state.content.assignPageFeature.checked[key]) {
        data.pages[key] = approved;
      }
    });
    if (rejectComment) {
      data.notes = rejectComment;
    }
    approve(data);
    setOpenDialog(false);
    setOpenNotification(true);
    setNotificationAction(approved);
    ChangeRejectComment('');
  };

  const handleOpenApprovalModal = (approved) => {
    let action = -1;
    if (approved === true) {
      action = 1;
    } else if (approved === 'with comments') {
      action = 3;
    } else {
      action = 2;
    }
    dispatch({
      type: contentActions.CONTENT_SET_ALL,
      payload: {
        assignPageFeature: {
          selectedAction: action,
        },
      },
    });
    setOpenDialog(true);
  };

  return (
    <>
      <div className={classes.wrapper}>
        <div className={classes.card}>
          <div className={classes.card__wrapper}>
            <div className={classes.card__header}>
              <div className={classes.heading} style={{ padding: 0 }}>
                Assigned Pages
              </div>
            </div>
            <Table>
              <TableHead>
                <TableRow>
                  <StyledContentTableHeadCell1 style={{ minWidth: 120 }}>
                    Select All
                    <Checkbox
                      checked={state.content.assignPageFeature.checkedAll}
                      onChange={handleCheckAll}
                      color="primary"
                      inputProps={{ 'aria-label': 'selectAll' }}
                    />
                  </StyledContentTableHeadCell1>
                  <StyledContentTableHeadCell>Date</StyledContentTableHeadCell>
                  <StyledContentTableHeadCell>Title</StyledContentTableHeadCell>
                  <StyledContentTableHeadCell>H1</StyledContentTableHeadCell>
                  <StyledContentTableHeadCell>URL</StyledContentTableHeadCell>
                  <StyledContentTableHeadCell>Google Document</StyledContentTableHeadCell>
                  <StyledContentTableHeadCell>Status</StyledContentTableHeadCell>
                  <StyledContentTableHeadCell2>Type</StyledContentTableHeadCell2>
                </TableRow>
              </TableHead>
              {!isInternalFetching && (
                <TableBody id="tableBody">
                  {state.content.assignPageFeature.total ? (
                    <>
                      {state.content.assignPageFeature.rows.map((row) => (
                        <>
                          {state.content.assignPageFeature.checked[row.id.toString()] === true ? (
                            <TableRow key={row.id}>
                              <StyledContentTableCell
                                component="th"
                                scope="row"
                                style={{ backgroundColor: '#f2f9ff' }}
                              >
                                <Checkbox
                                  checked={
                                    state.content.assignPageFeature.checked[row.id.toString()]
                                  }
                                  onChange={handleCheckBox}
                                  name={row.id.toString()}
                                  color="primary"
                                  inputProps={{ 'aria-label': 'checkbox' }}
                                />
                              </StyledContentTableCell>
                              <StyledContentTableCell
                                component="th"
                                scope="row"
                                style={{ backgroundColor: '#f2f9ff' }}
                              >
                                {row.date}
                              </StyledContentTableCell>
                              <StyledContentTableCell
                                component="th"
                                scope="row"
                                style={{ backgroundColor: '#f2f9ff' }}
                              >
                                {row.title_tag}
                              </StyledContentTableCell>
                              <StyledContentTableCell
                                component="th"
                                scope="row"
                                style={{ backgroundColor: '#f2f9ff' }}
                              >
                                {row.h1}
                              </StyledContentTableCell>

                              <StyledContentTableCell
                                component="th"
                                scope="row"
                                style={{ backgroundColor: '#f2f9ff' }}
                              >
                                <span>{row.url}</span>
                              </StyledContentTableCell>
                              <StyledContentTableCell
                                component="th"
                                scope="row"
                                style={{ backgroundColor: '#f2f9ff', minWidth: 150 }}
                              >
                                {row.google_doc_url ? (
                                  <a
                                    href={`${row.google_doc_url}&email=${state.auth.user.email}${state.auth.user.alternateEmail ? `&email=${state.auth.user.alternateEmail}` : ''}`}
                                    style={{ cursor: 'pointer', color: '#2A5CA9' }}
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    Open Content Page &gt;&gt;
                                  </a>
                                ) : (
                                  <p
                                    style={{
                                      cursor: 'not-allowed',
                                      color: '#2A5CA9',
                                      textDecoration: 'underline',
                                    }}
                                  >
                                    No Content Document
                                  </p>
                                )}
                              </StyledContentTableCell>
                              <StyledContentTableCell
                                component="th"
                                scope="row"
                                style={{ backgroundColor: '#f2f9ff' }}
                              >
                                {row.platform_status}
                              </StyledContentTableCell>
                              <StyledContentTableCell
                                component="th"
                                scope="row"
                                style={{ backgroundColor: '#f2f9ff' }}
                              >
                                {row.content_type}
                              </StyledContentTableCell>
                            </TableRow>
                          ) : (
                            <TableRow key={row.id}>
                              <StyledContentTableCell component="th" scope="row">
                                <Checkbox
                                  checked={
                                    state.content.assignPageFeature.checked[row.id.toString()]
                                  }
                                  onChange={handleCheckBox}
                                  name={row.id.toString()}
                                  color="primary"
                                  inputProps={{ 'aria-label': 'checkbox' }}
                                />
                              </StyledContentTableCell>
                              <StyledContentTableCell component="th" scope="row">
                                {row.date}
                              </StyledContentTableCell>
                              <StyledContentTableCell component="th" scope="row">
                                {row.title_tag}
                              </StyledContentTableCell>
                              <StyledContentTableCell component="th" scope="row">
                                {row.h1}
                              </StyledContentTableCell>

                              <StyledContentTableCell component="th" scope="row">
                                <span>{row.url}</span>
                              </StyledContentTableCell>
                              <StyledContentTableCell
                                component="th"
                                scope="row"
                                style={{ minWidth: 150 }}
                              >
                                {row.google_doc_url ? (
                                  <a
                                    href={`${row.google_doc_url}&email=${state.auth.user.email}${state.auth.user.alternateEmail ? `&email=${state.auth.user.alternateEmail}` : ''}`}
                                    style={{ cursor: 'pointer', color: '#2A5CA9' }}
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    Open Content Page &gt;&gt;
                                  </a>
                                ) : (
                                  <p
                                    style={{
                                      cursor: 'not-allowed',
                                      color: '#2A5CA9',
                                      textDecoration: 'underline',
                                    }}
                                  >
                                    No Content Document
                                  </p>
                                )}
                              </StyledContentTableCell>
                              <StyledContentTableCell component="th" scope="row">
                                {row.platform_status}
                              </StyledContentTableCell>
                              <StyledContentTableCell component="th" scope="row">
                                {row.content_type}
                              </StyledContentTableCell>
                            </TableRow>
                          )}
                        </>
                      ))}
                    </>
                  ) : (
                    <TableRow>
                      <StyledContentTableCell>No results</StyledContentTableCell>
                    </TableRow>
                  )}
                </TableBody>
              )}
            </Table>
          </div>
          {isInternalFetching && (
            <div className={classes.loading} style={{ height: tableBodyHeight }}>
              <CircularProgress />
            </div>
          )}
        </div>
        <Grow in={state.content.assignPageFeature.areSelected}>
          <div className={classes.popUp} style={{ margin: 'auto' }} aria-label="actions">
            <span className={classes.popUpText}>
              {state.content.assignPageFeature.totalChecked} items selected
            </span>
            <GreenButton onClick={() => handleOpenApprovalModal(true)} aria-label="action-approve">
              <p className={classes.approvalText}>Approve</p>
            </GreenButton>
            <RedButton onClick={() => handleOpenApprovalModal(false)}>
              <p className={classes.approvalText}>Disapprove</p>
            </RedButton>
            <GreenButton
              style={{ background: '#FFB946' }}
              onClick={() => handleOpenApprovalModal('with comments')}
            >
              <p className={classes.approvalText}>Approve With Comments</p>
            </GreenButton>
            <ClearIcon
              style={{ color: 'white', marginLeft: 20, cursor: 'pointer' }}
              onClick={() => handleCheckAll({ target: { checked: false } })}
            />
          </div>
        </Grow>
        <Snackbar
          open={openNotification}
          autoHideDuration={6000}
          onClose={handleNotificationClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          key="bottom left"
        >
          {notificationAction ? (
            <Alert onClose={handleNotificationClose} severity="success">
              Pages approved
            </Alert>
          ) : (
            <Alert onClose={handleNotificationClose} severity="error">
              Pages disapproved
            </Alert>
          )}
        </Snackbar>
        <Dialog
          open={openDialog}
          onClose={() => {
            setOpenDialog(false);
          }}
          aria-labelledby="form-dialog-title"
        >
          {(state.content.assignPageFeature.selectedAction === 1 ||
            state.content.assignPageFeature.selectedAction === 3) && (
            <>
              <DialogTitle id="form-dialog-title">
                Are you sure you want to approve the selected articles?
              </DialogTitle>
              {state.content.assignPageFeature.selectedAction !== 3 && (
                <DialogContent>
                  Approving these articles will place them “In Publishing”. Please contact your
                  account manager if you have any questions.
                </DialogContent>
              )}
              {state.content.assignPageFeature.selectedAction === 3 && (
                <DialogContent>
                  Approving these articles with comment will place them “Approved With Comments”.
                  Please contact your account manager if you have any questions.
                </DialogContent>
              )}
              {state.content.assignPageFeature.selectedAction === 3 && (
                <DefaultInput
                  rows={3}
                  className={classes.approveComment}
                  multiline
                  label="Comments"
                  variant="outlined"
                  value={rejectComment}
                  data-testid="details_test_id"
                  type="text"
                  onChange={(e) => {
                    ChangeRejectComment(e.target.value);
                  }}
                />
              )}
              <DialogActions>
                <Button
                  onClick={() => {
                    setOpenDialog(false);
                  }}
                  style={{ color: '#58595B' }}
                >
                  Cancel
                </Button>
                <GreenButton aria-label="submit won" onClick={() => handleApproveSelected(true)}>
                  Submit
                </GreenButton>
              </DialogActions>
            </>
          )}
          {state.content.assignPageFeature.selectedAction === 2 && (
            <>
              <DialogTitle id="form-dialog-title">
                Are you sure you want to reject the selected article?
              </DialogTitle>
              <DialogContent>
                Rejecting the article will place it back into “QA Editing.” Please be sure to add
                your reasons/revisions to the comments section of the articles.
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() => {
                    setOpenDialog(false);
                  }}
                  style={{ color: '#58595B' }}
                >
                  Cancel
                </Button>
                <RedButton aria-label="submit lost" onClick={() => handleApproveSelected(false)}>
                  Submit
                </RedButton>
              </DialogActions>
            </>
          )}
        </Dialog>
      </div>
    </>
  );
};

export default AssignedPages;
